<template>
  <div class="mobile-energy-station">
    <LinkTitle title="titles.mobileEnergyStation" />
    <div class="content">
      <div class="yuanqi">
        <div class="yuanqi-title">
          <h2>{{ $t(mobileEnergyStationData.title) }}</h2>
        </div>
        <div class="yuanqi-content">
          <div class="video-box">
            <video
              src="../../assets/Home/6.mp4"
              autoplay
              muted
              loop
            ></video>
          </div>
          <div class="yuanqi-list">
            <ul>
              <li
                v-for="(item, index) in mobileEnergyStationData.listItems"
                :key="index"
              >
                {{ $t(item) }}
              </li>
            </ul>
            <div class="yuanqi-btn" @click="learnMore" style="text-decoration: underline;">
              {{ $t(mobileEnergyStationData.buttonText) }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LinkTitle from "@/components/LinkTitle.vue";
export default {
  components: {
    LinkTitle,
  },
  data() {
    return {
      mobileEnergyStationData: {
        title: "mobileEnergyStation.title",
        listItems: [
          "mobileEnergyStation.listItems.travelAndProfit",
          "mobileEnergyStation.listItems.lightAssetOperation",
          "mobileEnergyStation.listItems.stressFreeStartup",
          "mobileEnergyStation.listItems.projectDescription",
        ],
        buttonText: "mobileEnergyStation.buttonText",
      },
    };
  },
  methods: {
    learnMore() {
      // this.$router.push("/Vitality");
      // 这里可以添加跳转页面或打开弹窗的逻辑
    },
  },
};
</script>

<style lang="less" scoped>
.mobile-energy-station {
  height: 36vw;
  letter-spacing: 0.1vw;
}

.content {
  .yuanqi {
    .yuanqi-title {
      text-align: center;
      padding-bottom: 2vw;

      h2 {
        font-size: 1.5vw;
        font-weight: 700;
      }
    }

    .yuanqi-content {
      background-color: #f3f2f2;
      width: 90%;
      margin: 0 auto;
      display: flex;
      padding: 0.8vw;
      border-radius: 0.5vw;

      .video-box {
        width: 70%;
        flex-shrink: 0;

        video {
          width: 100%;
          height: auto;
          object-fit: cover;
        }
      }

      .yuanqi-list {
        width: 40%;
        padding: 1.5vw 0 1.5vw 1.5vw;

        ul {
          li {
            line-height: 3vw;
            font-size: 0.8vw;
            display: flex;
            align-items: center;

            &::before {
              content: "";
              display: inline-block;
              width: 0.3vw;
              height: 0.3vw;
              background-color: #d01814;
              border-radius: 50%;
              margin-right: 0.5vw;
              line-height: 0.5vw;
            }

            &:nth-child(1) {
              font-size: 1.2vw;
            }
          }
        }

        .yuanqi-btn {
          width: 8vw;
          height: 2vw;
          line-height: 2vw;
          background-color: #fff;
          color: #000;
          text-align: center;
          border-radius: 2vw;
          margin: 3vw 3vw 0 3vw;
          font-size: 0.8vw;
          cursor: pointer;
        }
      }
    }
  }
}
@media screen and (max-width: 940px) {
  .mobile-energy-station {
    height: 36vw;
    letter-spacing: 0.1vw;
  }

  .content {
    .yuanqi {
      .yuanqi-title {
        text-align: center;
        padding-bottom: 2vw;

        h2 {
          font-size: 2.5vw;
          font-weight: 700;
        }
      }

      .yuanqi-content {
        background-color: #f3f2f2;
        width: 90%;
        margin: 0 auto;
        display: flex;
        padding: 0.8vw;
        border-radius: 0.5vw;

        .video-box {
          width: 70%;
          flex-shrink: 0;

          video {
            width: 100%;
            height: auto;
            object-fit: cover;
          }
        }

        .yuanqi-list {
          width: 40%;
          padding: 1.5vw 0 1.5vw 1.5vw;

          ul {
            li {
              line-height: 3vw;
              font-size: 1.8vw;
              display: flex;
              align-items: center;
              margin-top: 0.2rem;

              &::before {
                content: "";
                display: inline-block;
                width: 0.8vw;
                height: 0.8vw;
                background-color: #1e901d;
                border-radius: 50%;
                margin-right: 0.5vw;
                line-height: 0.5vw;
              }

              &:nth-child(1) {
                font-size: 2.2vw;

                &::before {
                  content: none; /* 隐藏第一个点 */
                  /* 或者用 display: none; 也行 */
                }
              }
            }
          }

          .yuanqi-btn {
            width: 8vw;
            height: 2vw;
            line-height: 2vw;
            background-color: #fff;
            color: #000;
            text-align: center;
            border-radius: 2vw;
            margin: 3vw 3vw 0 3vw;
            font-size: 1.8vw;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>